module.exports = __webpack_public_path__ + "static/media/journalBoomer.290253d2.png";